module.exports = __webpack_public_path__ + "img/SYZpepLogo.70145fd4.png";